import { render } from "./FormBusquedas.vue?vue&type=template&id=f0306978&scoped=true"
import script from "./FormBusquedas.vue?vue&type=script&lang=js"
export * from "./FormBusquedas.vue?vue&type=script&lang=js"

import "./FormBusquedas.vue?vue&type=style&index=0&id=f0306978&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0306978"

export default script